import { BrandsPage } from 'pages/brands';

export const BrandsView = () => {
  return <BrandsPage />;
};
